// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* P7-VISUAL-R1 — scoped Overview + inner pill nav. Do not import prototype chrome. */

.ms-pill-nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    list-style: none;
    margin: 0 0 24px;
    padding: 12px;
    background: #0b3454;
    border-radius: 12px;
}

.ms-pill-nav > li {
    margin: 0;
}

.ms-pill-tab {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 999px;
    background: #fff;
    color: #1d4ed8;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
}

.ms-pill-tab:hover {
    background: #f8fafc;
    color: #1e3a8a;
}

.ms-pill-tab.is-active {
    background: #5cae48;
    border-color: #5cae48;
    color: #fff;
}

.ms-pill-tab.is-active:hover {
    background: #4f9a3e;
    color: #fff;
}

.ms-pill-tab i {
    font-size: 14px;
}

.ms-pill-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
}

.ms-pill-badge--pool {
    background: #2563eb;
    color: #fff;
}

.ms-pill-badge--match {
    background: #f5a623;
    color: #1f2937;
}

.ms-pill-tab.is-active .ms-pill-badge--pool,
.ms-pill-tab.is-active .ms-pill-badge--match {
    background: rgba(255, 255, 255, 0.95);
    color: #0b3454;
}

.ms-ov {
    color: #1f2937;
}

.ms-ov-header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.ms-ov-title {
    margin: 0 0 4px;
    font-size: 22px;
    font-weight: 700;
    color: #111827;
}

.ms-ov-sub {
    margin: 0;
    font-size: 13px;
    color: #6b7280;
}

.ms-ov-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.ms-ov-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 16px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
}

.ms-ov-btn--ghost {
    border: 1px solid #d1d5db;
    background: #fff;
    color: #374151;
}

.ms-ov-btn--ghost:hover {
    background: #f9fafb;
    color: #111827;
}

.ms-ov-btn--green {
    border: 1px solid #5cae48;
    background: #5cae48;
    color: #fff;
}

.ms-ov-btn--green:hover {
    background: #4f9a3e;
    color: #fff;
}

.ms-ov-status {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 16px;
    padding: 4px;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
}

.ms-ov-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border: 0;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    background: transparent;
    color: #6b7280;
}

.ms-ov-chip.is-on.is-setup,
.ms-ov-chip.is-on.is-done {
    background: #2563eb;
    color: #fff;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.ms-ov-chip.is-on.is-live {
    background: #fff;
    color: #111827;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.ms-ov-dot {
    font-size: 8px;
    color: #22c55e;
}

.ms-ov-chip.is-on.is-setup .ms-ov-dot,
.ms-ov-chip.is-on.is-done .ms-ov-dot {
    color: #bfdbfe;
}

.ms-ov-stepper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.ms-ov-step {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ms-ov-step-dot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid #e5e7eb;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
}

.ms-ov-step-label {
    font-size: 13px;
    font-weight: 400;
    color: #6b7280;
    white-space: nowrap;
}

.ms-ov-step.is-complete .ms-ov-step-dot {
    background: #22c55e;
    border-color: #22c55e;
    color: #fff;
}

.ms-ov-step.is-complete .ms-ov-step-label {
    color: #16a34a;
    font-weight: 700;
}

.ms-ov-step.is-current .ms-ov-step-dot {
    background: #2563eb;
    border-color: #2563eb;
    color: #fff;
}

.ms-ov-step.is-current .ms-ov-step-label {
    color: #2563eb;
    font-weight: 700;
}

.ms-ov-step-line {
    flex: 1 1 24px;
    min-width: 16px;
    height: 0;
    border-bottom: 2px solid #e5e7eb;
}

.ms-ov-step-line.is-done {
    border-bottom-color: #22c55e;
}

.ms-ov-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
    margin-bottom: 20px;
}

.ms-ov-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
    background: #fff;
    border: 0;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.ms-ov-card-kicker {
    margin-bottom: 6px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #6b7280;
}

.ms-ov-card-value {
    margin-bottom: 4px;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.1;
    color: #6b7280;
}

.ms-ov-card-value.is-green {
    color: #16a34a;
}

.ms-ov-card-value.is-blue {
    color: #2563eb;
}

.ms-ov-card-value.is-amber {
    color: #d97706;
}

.ms-ov-card-value.is-danger {
    color: #dc2626;
}

.ms-ov-card-sub {
    margin-bottom: 8px;
    font-size: 12px;
    line-height: 1.35;
    color: #6b7280;
}

.ms-ov-chip-mini {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 600;
}

.ms-ov-chip-mini.is-warn {
    background: #fef3c7;
    color: #92400e;
}

.ms-ov-chip-mini.is-ok {
    background: #dcfce7;
    color: #166534;
}

.ms-ov-chip-mini.is-muted {
    background: #f3f4f6;
    color: #4b5563;
}

.ms-ov-card-note {
    margin-top: 8px;
    font-size: 11px;
    line-height: 1.4;
    color: #6b7280;
}

.ms-ov-card-note.is-error {
    color: #dc2626;
}

.ms-ov-lock-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #111827;
}

.ms-ov-lock-row i {
    font-size: 18px;
    color: #d97706;
}

.ms-ov-lock-row.is-open i {
    color: #16a34a;
}

.ms-ov-card-link {
    margin-top: auto;
    padding-top: 8px;
    font-size: 11px;
    font-weight: 700;
    color: #d97706;
    background: none;
    border: 0;
    padding-left: 0;
    text-align: left;
}

.ms-ov-card-link:hover {
    color: #b45309;
    text-decoration: underline;
}

.ms-ov-section {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
    overflow: hidden;
}

.ms-ov-section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 14px 16px;
    border-bottom: 1px solid #f3f4f6;
}

.ms-ov-section-title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #111827;
}

.ms-ov-section-link {
    font-size: 13px;
    font-weight: 500;
    color: #2563eb;
    text-decoration: none;
}

.ms-ov-section-link:hover {
    text-decoration: underline;
}

.ms-ov-section-body {
    padding: 16px;
}

.ms-ov-muted {
    color: #6b7280;
    font-size: 13px;
    line-height: 1.45;
}

.ms-ov-muted-card {
    background: #f8fafc;
    border: 1px dashed #d1d5db;
    border-radius: 10px;
    padding: 14px;
    color: #6b7280;
    font-size: 13px;
}

.ms-ov-qa {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
}

.ms-ov-qa-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    width: 100%;
    min-height: 108px;
    padding: 16px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #fff;
    text-align: center;
}

.ms-ov-qa-btn:hover:not(:disabled) {
    border-color: #bfdbfe;
    background: #f8fbff;
}

.ms-ov-qa-btn:disabled {
    opacity: 0.72;
    cursor: not-allowed;
}

.ms-ov-qa-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #eef2ff;
    color: #3557cc;
    font-size: 20px;
}

.ms-ov-qa-label {
    font-size: 13px;
    font-weight: 700;
    color: #111827;
}

.ms-ov-qa-note {
    font-size: 11px;
    font-weight: 400;
    color: #6b7280;
    line-height: 1.35;
}

.ms-ov-bars {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.ms-ov-bar-label {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
    font-size: 12px;
    color: #4b5563;
}

.ms-ov-bar {
    height: 8px;
    overflow: hidden;
    background: #e5e7eb;
    border-radius: 999px;
}

.ms-ov-bar > span {
    display: block;
    height: 100%;
    background: #2563eb;
    border-radius: 999px;
}

.ms-ov-warn {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 12px;
    margin-bottom: 20px;
}

.ms-ov-warn-title {
    font-weight: 700;
    color: #92400e;
}

.ms-ov-split {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 20px;
}

@media (min-width: 992px) {
    .ms-ov-split {
        grid-template-columns: 1fr 1fr;
    }

    .ms-ov-step-line {
        display: block;
    }
}

@media (max-width: 767px) {
    .ms-ov-step-line {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/management/mentorship/MentorshipOverviewVisual.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* P7-VISUAL-R1 — scoped Overview + inner pill nav. Do not import prototype chrome. */\n\n.ms-pill-nav {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    list-style: none;\n    margin: 0 0 24px;\n    padding: 12px;\n    background: #0b3454;\n    border-radius: 12px;\n}\n\n.ms-pill-nav > li {\n    margin: 0;\n}\n\n.ms-pill-tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-height: 36px;\n    padding: 6px 14px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    border-radius: 999px;\n    background: #fff;\n    color: #1d4ed8;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.2;\n    white-space: nowrap;\n}\n\n.ms-pill-tab:hover {\n    background: #f8fafc;\n    color: #1e3a8a;\n}\n\n.ms-pill-tab.is-active {\n    background: #5cae48;\n    border-color: #5cae48;\n    color: #fff;\n}\n\n.ms-pill-tab.is-active:hover {\n    background: #4f9a3e;\n    color: #fff;\n}\n\n.ms-pill-tab i {\n    font-size: 14px;\n}\n\n.ms-pill-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 22px;\n    height: 22px;\n    padding: 0 6px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1;\n}\n\n.ms-pill-badge--pool {\n    background: #2563eb;\n    color: #fff;\n}\n\n.ms-pill-badge--match {\n    background: #f5a623;\n    color: #1f2937;\n}\n\n.ms-pill-tab.is-active .ms-pill-badge--pool,\n.ms-pill-tab.is-active .ms-pill-badge--match {\n    background: rgba(255, 255, 255, 0.95);\n    color: #0b3454;\n}\n\n.ms-ov {\n    color: #1f2937;\n}\n\n.ms-ov-header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.ms-ov-title {\n    margin: 0 0 4px;\n    font-size: 22px;\n    font-weight: 700;\n    color: #111827;\n}\n\n.ms-ov-sub {\n    margin: 0;\n    font-size: 13px;\n    color: #6b7280;\n}\n\n.ms-ov-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.ms-ov-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-height: 36px;\n    padding: 6px 16px;\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.ms-ov-btn--ghost {\n    border: 1px solid #d1d5db;\n    background: #fff;\n    color: #374151;\n}\n\n.ms-ov-btn--ghost:hover {\n    background: #f9fafb;\n    color: #111827;\n}\n\n.ms-ov-btn--green {\n    border: 1px solid #5cae48;\n    background: #5cae48;\n    color: #fff;\n}\n\n.ms-ov-btn--green:hover {\n    background: #4f9a3e;\n    color: #fff;\n}\n\n.ms-ov-status {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-bottom: 16px;\n    padding: 4px;\n    background: #f3f4f6;\n    border: 1px solid #e5e7eb;\n    border-radius: 999px;\n}\n\n.ms-ov-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 14px;\n    border: 0;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n    background: transparent;\n    color: #6b7280;\n}\n\n.ms-ov-chip.is-on.is-setup,\n.ms-ov-chip.is-on.is-done {\n    background: #2563eb;\n    color: #fff;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);\n}\n\n.ms-ov-chip.is-on.is-live {\n    background: #fff;\n    color: #111827;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.ms-ov-dot {\n    font-size: 8px;\n    color: #22c55e;\n}\n\n.ms-ov-chip.is-on.is-setup .ms-ov-dot,\n.ms-ov-chip.is-on.is-done .ms-ov-dot {\n    color: #bfdbfe;\n}\n\n.ms-ov-stepper {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 20px;\n    padding: 12px 16px;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n\n.ms-ov-step {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.ms-ov-step-dot {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    border: 1px solid #e5e7eb;\n    background: #f3f4f6;\n    color: #6b7280;\n    font-size: 12px;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.ms-ov-step-label {\n    font-size: 13px;\n    font-weight: 400;\n    color: #6b7280;\n    white-space: nowrap;\n}\n\n.ms-ov-step.is-complete .ms-ov-step-dot {\n    background: #22c55e;\n    border-color: #22c55e;\n    color: #fff;\n}\n\n.ms-ov-step.is-complete .ms-ov-step-label {\n    color: #16a34a;\n    font-weight: 700;\n}\n\n.ms-ov-step.is-current .ms-ov-step-dot {\n    background: #2563eb;\n    border-color: #2563eb;\n    color: #fff;\n}\n\n.ms-ov-step.is-current .ms-ov-step-label {\n    color: #2563eb;\n    font-weight: 700;\n}\n\n.ms-ov-step-line {\n    flex: 1 1 24px;\n    min-width: 16px;\n    height: 0;\n    border-bottom: 2px solid #e5e7eb;\n}\n\n.ms-ov-step-line.is-done {\n    border-bottom-color: #22c55e;\n}\n\n.ms-ov-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n.ms-ov-card {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 16px;\n    background: #fff;\n    border: 0;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n\n.ms-ov-card-kicker {\n    margin-bottom: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #6b7280;\n}\n\n.ms-ov-card-value {\n    margin-bottom: 4px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.1;\n    color: #6b7280;\n}\n\n.ms-ov-card-value.is-green {\n    color: #16a34a;\n}\n\n.ms-ov-card-value.is-blue {\n    color: #2563eb;\n}\n\n.ms-ov-card-value.is-amber {\n    color: #d97706;\n}\n\n.ms-ov-card-value.is-danger {\n    color: #dc2626;\n}\n\n.ms-ov-card-sub {\n    margin-bottom: 8px;\n    font-size: 12px;\n    line-height: 1.35;\n    color: #6b7280;\n}\n\n.ms-ov-chip-mini {\n    display: inline-block;\n    padding: 3px 8px;\n    border-radius: 999px;\n    font-size: 10px;\n    font-weight: 600;\n}\n\n.ms-ov-chip-mini.is-warn {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.ms-ov-chip-mini.is-ok {\n    background: #dcfce7;\n    color: #166534;\n}\n\n.ms-ov-chip-mini.is-muted {\n    background: #f3f4f6;\n    color: #4b5563;\n}\n\n.ms-ov-card-note {\n    margin-top: 8px;\n    font-size: 11px;\n    line-height: 1.4;\n    color: #6b7280;\n}\n\n.ms-ov-card-note.is-error {\n    color: #dc2626;\n}\n\n.ms-ov-lock-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #111827;\n}\n\n.ms-ov-lock-row i {\n    font-size: 18px;\n    color: #d97706;\n}\n\n.ms-ov-lock-row.is-open i {\n    color: #16a34a;\n}\n\n.ms-ov-card-link {\n    margin-top: auto;\n    padding-top: 8px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #d97706;\n    background: none;\n    border: 0;\n    padding-left: 0;\n    text-align: left;\n}\n\n.ms-ov-card-link:hover {\n    color: #b45309;\n    text-decoration: underline;\n}\n\n.ms-ov-section {\n    margin-bottom: 20px;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n    overflow: hidden;\n}\n\n.ms-ov-section-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 14px 16px;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.ms-ov-section-title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n}\n\n.ms-ov-section-link {\n    font-size: 13px;\n    font-weight: 500;\n    color: #2563eb;\n    text-decoration: none;\n}\n\n.ms-ov-section-link:hover {\n    text-decoration: underline;\n}\n\n.ms-ov-section-body {\n    padding: 16px;\n}\n\n.ms-ov-muted {\n    color: #6b7280;\n    font-size: 13px;\n    line-height: 1.45;\n}\n\n.ms-ov-muted-card {\n    background: #f8fafc;\n    border: 1px dashed #d1d5db;\n    border-radius: 10px;\n    padding: 14px;\n    color: #6b7280;\n    font-size: 13px;\n}\n\n.ms-ov-qa {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 12px;\n}\n\n.ms-ov-qa-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    width: 100%;\n    min-height: 108px;\n    padding: 16px 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    background: #fff;\n    text-align: center;\n}\n\n.ms-ov-qa-btn:hover:not(:disabled) {\n    border-color: #bfdbfe;\n    background: #f8fbff;\n}\n\n.ms-ov-qa-btn:disabled {\n    opacity: 0.72;\n    cursor: not-allowed;\n}\n\n.ms-ov-qa-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: #eef2ff;\n    color: #3557cc;\n    font-size: 20px;\n}\n\n.ms-ov-qa-label {\n    font-size: 13px;\n    font-weight: 700;\n    color: #111827;\n}\n\n.ms-ov-qa-note {\n    font-size: 11px;\n    font-weight: 400;\n    color: #6b7280;\n    line-height: 1.35;\n}\n\n.ms-ov-bars {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.ms-ov-bar-label {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 6px;\n    font-size: 12px;\n    color: #4b5563;\n}\n\n.ms-ov-bar {\n    height: 8px;\n    overflow: hidden;\n    background: #e5e7eb;\n    border-radius: 999px;\n}\n\n.ms-ov-bar > span {\n    display: block;\n    height: 100%;\n    background: #2563eb;\n    border-radius: 999px;\n}\n\n.ms-ov-warn {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 14px 16px;\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n    border-radius: 12px;\n    margin-bottom: 20px;\n}\n\n.ms-ov-warn-title {\n    font-weight: 700;\n    color: #92400e;\n}\n\n.ms-ov-split {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n@media (min-width: 992px) {\n    .ms-ov-split {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .ms-ov-step-line {\n        display: block;\n    }\n}\n\n@media (max-width: 767px) {\n    .ms-ov-step-line {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
